import { createClient } from '@supabase/supabase-js';

// Same Supabase project as the estimator. HQ keeps its OWN session
// (localStorage on the hq. origin), obtained via the /sso handoff.
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false } },
);
